var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIronAndSteel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 21C0 9.40204 9.40202 0 21 0C32.598 0 42 9.40204 42 21C42 32.598 32.598 42 21 42C9.40202 42 0 32.598 0 21Z",
    fill: "#EDFEF0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_84)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.25 15.75H15.75C14.5074 15.75 13.5 16.7574 13.5 18V24C13.5 25.2426 14.5074 26.25 15.75 26.25H26.25C27.4926 26.25 28.5 25.2426 28.5 24V18C28.5 16.7574 27.4926 15.75 26.25 15.75Z",
    fill: "#00A852"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_84"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIronAndSteel);
export default __webpack_public_path__ + "static/media/iron_and_steel.a12462e916b74ef811c0735023628207.svg";
export { ForwardRef as ReactComponent };